// View-as sessions stay in the audit log; the Admin Panel just doesn't show them unless
// asked (Drew, 2026-11-02: "hide them by default and have them there"). He views as
// advisors during their meetings to check an update is running right, and those start
// and end rows buried everything else. They are still written, still exportable, and
// still the record of who looked at whose data.

export const VIEW_AS_ACTIONS = ['impersonation.started', 'impersonation.ended'] as const;

export function isViewAs(action: string): boolean {
  return (VIEW_AS_ACTIONS as readonly string[]).includes(action);
}

/** The rows the Audit log list and its CSV export show: everything, or everything but View-as. */
export function visibleAudit<T extends { action: string }>(rows: T[], showViewAs: boolean): T[] {
  return showViewAs ? rows : rows.filter((r) => !isViewAs(r.action));
}

/** PostgREST `in` list for excluding View-as rows server-side, so the 200-row window holds real events. */
export const VIEW_AS_IN_LIST = `(${VIEW_AS_ACTIONS.join(',')})`;
